// extracted by mini-css-extract-plugin
export default {"modalContainer":"qv","fadeRight":"rv","fadeUp":"sv","topShelf":"tv","newFlavorBadge":"uv","transparentText":"vv","cancelButton":"wv","invisibleLink":"xv","closeIcon":"yv","linkContainer":"zv","hed":"Av","image":"Bv"};
    if(module.hot) {
      // 1713211512788
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  